export default __webpack_public_path__ + "static/Artist-28cf5962849e6a9925b1d37d9550bf21.png";